// This file is used for manual configuration of the Amplify library.
// When Amplify is used in conjunction with the Amplify CLI toolchain or AWS Mobile Hub to manage backend resources,
// an aws-exports.js file is auto-generated and can be used instead of the below to automatically configure the Amplify library.
// In this workshop, we are using the Amplify client libraries without the CLI toolchain so you should edit this file manually.

const awsConfig = {
    Auth: {
        identityPoolId: '', // example: 'us-east-2:c85f3c18-05fd-4bb5-8fd1-e77e7627a99e'
        region: 'ap-southeast-1', // example: 'us-east-2'
        userPoolId: process.env.REACT_APP_USER_POOL_ID,//'ap-southeast-1_oVHtZXH3D', // example: 'us-east-2_teEUQbkUh'
        userPoolWebClientId: process.env.REACT_APP_USER_CLIENT_ID //'4fm5u115vqs95ur5ihffbn9c87', // example: '3k09ptd8kn8qk2hpk07qopr86'
    },
    authenticationFlowType: 'CUSTOM_AUTH'
}


export default awsConfig;
